/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "ok-white-412c7eb3--sprite",
  "use": "ok-white-412c7eb3--sprite-usage",
  "viewBox": "0 0 16 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 25\" id=\"ok-white-412c7eb3--sprite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.77 17.354c-1.936-.197-3.682-.658-5.177-1.789-.185-.141-.377-.276-.547-.434-.653-.607-.72-1.305-.202-2.022.444-.614 1.187-.779 1.96-.425.15.067.291.154.429.245 2.786 1.852 6.612 1.903 9.41.082a2.58 2.58 0 01.916-.458c.667-.166 1.29.072 1.647.637.41.645.404 1.275-.1 1.775-.774.769-1.704 1.325-2.737 1.712-.976.367-2.046.55-3.107.674.16.169.236.25.335.349 1.438 1.398 2.884 2.791 4.318 4.194.488.477.59 1.07.321 1.626-.293.608-.952 1.008-1.597.965-.41-.027-.729-.225-1.013-.5-1.085-1.058-2.19-2.095-3.253-3.172-.31-.313-.46-.254-.732.018a218.3 218.3 0 01-3.319 3.224c-.5.479-1.097.564-1.678.291-.619-.29-1.013-.9-.982-1.514.022-.415.233-.732.527-1.016 1.423-1.375 2.843-2.755 4.262-4.132.095-.091.183-.189.319-.33z\" fill=\"#fff\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.955 12.5C4.67 12.489 1.98 9.771 1.999 6.488A6.013 6.013 0 018.026.5C11.35.509 14.015 3.223 14 6.578c-.02 3.277-2.73 5.932-6.045 5.922zm2.984-6.005a2.924 2.924 0 00-2.937-2.93 2.929 2.929 0 00-2.94 2.965 2.925 2.925 0 002.957 2.908 2.919 2.919 0 002.92-2.943z\" fill=\"#fff\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
